

function JoyTycoonTent(type_id,config,configOrg) {
  myPixiElement.container.call(this);

  this.config = {
    onCustomerEnd:function () {}
  };
  if(typeof configOrg.tentsConfig[type_id] !== "undefined") {
    this.config = $.extend(this.config,configOrg.tentsConfig[type_id]);
  }

  this.config = $.extend(this.config,config);
  this.configOrg = configOrg;
  this.width = this.config.size.width;
  this.height = this.config.size.height;
  this.x = this.config.pos.x;
  this.y = this.config.pos.y;
  this.containerTime = new myPixiObj.showText("free",{
    pos:[0,0],
    font_color:"#97ef2f",
    border_color:"#0e498f",
    border_size:4,
    font_size:32,
  });
  this.customerIn={};
  this.busyTime = 0;
  this.timerEnd = 0;
  this.time = 0;
  this.type_id = type_id;
  this.addRect();
}
JoyTycoonTent.prototype = Object.create(myPixiElement.container.prototype);
JoyTycoonTent.prototype = $.extend(JoyTycoonTent.prototype, {
  addCustomer:function (c,speedPremiumTime) {
    if(typeof c == "undefined") {
      return 0;
    }
    var customer = new JoyTycoonCustomer(c,{posX:0,posY:0,hideObjects:1},this.configOrg),
        speedPremium = (typeof speedPremiumTime !== "undefined" && speedPremiumTime);
    customer.init();
    this.customerIn = customer;
    // this.addChild(customer);
    // this.addChild(this.containerTime);

    this.busyTime = this.config.busyTime;
    if(speedPremium){
      this.busyTime=this.config.busyTimePrem;
    }
    this.timerEnd = $.getCurrentTime()+this.busyTime;
    this.time = $.getCurrentTime();
  },
  clearTent:function () {
    if(typeof this.config.onCustomerEnd == "function") {
      this.config.onCustomerEnd(this.customerIn.type_id,this.type_id);
    }
    this.removeChildren();
    this.customerIn={};
    this.addRect();
    this.timerEnd=0;
  },
  addRect:function () {
    return 0;
    var graph = new PIXI.Graphics();
    graph.lineStyle(1,"0xFF0000");
    graph.drawRect(0,0,this.config.size.width,this.config.size.height);
    this.addChild(graph);
  },
  updateTime:function () {
    var time = this.timerEnd-$.getCurrentTime(),clear=false;
    if(this.timerEnd>0 && this.time <= $.getCurrentTime()){
      this.containerTime.changeText(timeFormat(time));
      this.time = $.getCurrentTime();
      if(time<0){
        time = 0;
      }
      this.busyTime = time;
      clear=true;
    }
    if(clear && this.busyTime == 0){
      this.clearTent();
      time=0;
    }
  },
  update:function (delta) {
    this.myUpdate(delta);
    this.updateTime();
  }
});

